import './config/configure-sentry';

import React from 'react';
import { createRoot } from 'react-dom/client';
import debug from 'debug';
import { AuthProvider } from 'oidc-react';
import { AuthenticatedProvider } from 'core/data/authenticated';
import { authProviderProps, userManager } from './config';
import App from './app';

if (process.env.NODE_ENV !== 'production') {
  debug.enable('evp:*');
}

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <AuthenticatedProvider initialState='unknown'>
    <AuthProvider {...authProviderProps} userManager={userManager}>
      <App />
    </AuthProvider>
  </AuthenticatedProvider>,
);
